import React from "react";
import LocationMap from "../../../components/contact/contact-map";
import styles from "./ContactMap.module.scss";

const ContactMap = () => {
  return (
    <div className={`${styles.voopoAddress} bg--cart-10`}>
      <div className="container">
        <div className="row">
          <div className="col-12 col-md-7 col-lg-5">
            <div className={styles.vpContactAddress}>
              <h2>Out Contact Info</h2>
              <div className="vp__address__container">
                {/* Start Single Address */}
                <div className={styles.vpAddress}>
                  <h4>Phone</h4>
                  <p><a href="tel:+1 (877) 514-5141">(877) 514-5141</a></p>
                </div>
                {/* End Single Address */}
                {/* Start Single Address */}
                <div className={styles.vpAddress}>
                  <h4>Email</h4>
                  <p>
                    <a href="mailto:info@adaptivesystems-llc.com">info@adaptivesystems-llc.com</a>
                  </p>
                </div>
                {/* End Single Address */}
                {/* Start Single Address */}
                <div className={styles.vpAddress}>
                  <h4>Address</h4>
                  <p>
                    2420 Kates Pl ,Prosper, TX 75078
                  </p>
                </div>
                {/* End Single Address */}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.googleMap}>
        {/* location map */}
        {/* <LocationMap latitude="47.444" longitude="-122.176" /> */}
      </div>
    </div>
  );
};

export default ContactMap;
